const mapData = {
  title: "Nebraska",
  version: "1.1.3",
  type: "FeatureCollection",
  copyright:
    "Copyright (c) 2020 Highsoft AS, Based on data from The United States Census Bureau",
  copyrightShort: "USA Census Bureau",
  copyrightUrl: "http://www.census.gov",
  crs: {
    type: "name",
    properties: {
      name: "urn:ogc:def:crs:EPSG:102304",
    },
  },
  "hc-transform": {
    default: {
      crs: "+proj=lcc +lat_1=40 +lat_2=43 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
      scale: 0.00094437359756,
      jsonres: 15.5,
      jsonmarginX: -999,
      jsonmarginY: 9851,
      xoffset: 159214.548321,
      yoffset: 359431.094813,
    },
  },
  features: [
    {
      type: "Feature",
      id: "US.NE.085",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-085",
        "hc-a2": "HA",
        fips: "31085",
        name: "Hayes",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2622, 5440],
            [2344, 5443],
            [2334, 5443],
            [2320, 5443],
            [2322, 5727],
            [2325, 6008],
            [2423, 6006],
            [2446, 6006],
            [2752, 6005],
            [3027, 6003],
            [3019, 5745],
            [3023, 5433],
            [3023, 5433],
            [3023, 5433],
            [2622, 5440],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.087",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-087",
        "hc-a2": "HI",
        fips: "31087",
        name: "Hitchcock",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2622, 5440],
            [3023, 5433],
            [3023, 5433],
            [3023, 5433],
            [3034, 5433],
            [3046, 5433],
            [3041, 5149],
            [3041, 4869],
            [2818, 4870],
            [2333, 4878],
            [2341, 5409],
            [2344, 5443],
            [2622, 5440],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.037",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.42,
        "hc-key": "us-ne-037",
        "hc-a2": "CO",
        fips: "31037",
        name: "Colfax",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7771, 7295],
            [7700, 7269],
            [7640, 7221],
            [7589, 7217],
            [7548, 7184],
            [7446, 7155],
            [7350, 7164],
            [7351, 7181],
            [7333, 7747],
            [7467, 7751],
            [7616, 7756],
            [7673, 7758],
            [7755, 7760],
            [7761, 7579],
            [7772, 7292],
            [7771, 7295],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.053",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.4,
        "hc-middle-y": 0.48,
        "hc-key": "us-ne-053",
        "hc-a2": "DO",
        fips: "31053",
        name: "Dodge",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7771, 7295],
            [7761, 7579],
            [7755, 7760],
            [7985, 7768],
            [8181, 7775],
            [8316, 7780],
            [8320, 7686],
            [8331, 7427],
            [8357, 7357],
            [8405, 7335],
            [8431, 7289],
            [8478, 7291],
            [8481, 7220],
            [8344, 7214],
            [8307, 7213],
            [8276, 7213],
            [8185, 7273],
            [8097, 7274],
            [8031, 7255],
            [7966, 7291],
            [7878, 7273],
            [7772, 7290],
            [7772, 7292],
            [7771, 7295],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.157",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-157",
        "hc-a2": "SB",
        fips: "31157",
        name: "Scotts Bluff",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-679, 8216],
            [-133, 8198],
            [-112, 8197],
            [-87, 8195],
            [-103, 7774],
            [-115, 7702],
            [-487, 7715],
            [-945, 7736],
            [-943, 7783],
            [-922, 8229],
            [-679, 8216],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.165",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-165",
        "hc-a2": "SI",
        fips: "31165",
        name: "Sioux",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-133, 8198],
            [-679, 8216],
            [-922, 8229],
            [-846, 9851],
            [-193, 9823],
            [-205, 9472],
            [-178, 9471],
            [-200, 8906],
            [-157, 8904],
            [-179, 8341],
            [-128, 8339],
            [-133, 8198],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.059",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-059",
        "hc-a2": "FI",
        fips: "31059",
        name: "Fillmore",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7244, 6046],
            [7259, 5520],
            [7261, 5480],
            [7261, 5480],
            [7261, 5480],
            [7170, 5477],
            [6699, 5464],
            [6698, 5464],
            [6695, 5464],
            [6682, 5945],
            [6679, 6030],
            [6679, 6030],
            [6885, 6035],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.169",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-169",
        "hc-a2": "TH",
        fips: "31169",
        name: "Thayer",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7261, 5480],
            [7265, 5315],
            [7277, 4914],
            [6804, 4901],
            [6712, 4898],
            [6711, 4971],
            [6699, 5464],
            [6698, 5464],
            [7170, 5477],
            [7261, 5480],
            [7261, 5480],
            [7261, 5480],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.083",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-083",
        "hc-a2": "HA",
        fips: "31083",
        name: "Harlan",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4449, 5432],
            [4691, 5433],
            [5010, 5435],
            [5012, 5164],
            [5015, 4869],
            [4852, 4867],
            [4454, 4865],
            [4451, 5006],
            [4449, 5432],
            [4449, 5432],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.065",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-065",
        "hc-a2": "FU",
        fips: "31065",
        name: "Furnas",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4449, 5432],
            [4451, 5006],
            [4454, 4865],
            [4223, 4863],
            [3747, 4864],
            [3746, 5315],
            [3743, 5430],
            [3820, 5431],
            [3871, 5432],
            [4131, 5431],
            [4434, 5432],
            [4449, 5432],
            [4449, 5432],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.179",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.36,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-179",
        "hc-a2": "WA",
        fips: "31179",
        name: "Wayne",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7175, 8307],
            [7174, 8336],
            [7163, 8731],
            [7420, 8739],
            [7585, 8744],
            [7589, 8603],
            [7825, 8611],
            [7828, 8520],
            [7834, 8329],
            [7733, 8325],
            [7597, 8320],
            [7357, 8313],
            [7175, 8307],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.139",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-139",
        "hc-a2": "PI",
        fips: "31139",
        name: "Pierce",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7163, 8731],
            [7174, 8336],
            [7175, 8307],
            [6893, 8298],
            [6611, 8290],
            [6606, 8455],
            [6597, 8855],
            [6765, 8860],
            [7017, 8868],
            [7159, 8872],
            [7163, 8731],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.077",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-077",
        "hc-a2": "GR",
        fips: "31077",
        name: "Greeley",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6064, 7711],
            [6070, 7711],
            [6077, 7288],
            [6079, 7194],
            [6080, 7147],
            [5824, 7142],
            [5526, 7138],
            [5519, 7137],
            [5517, 7137],
            [5514, 7396],
            [5508, 7700],
            [5724, 7703],
            [6064, 7711],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.011",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-011",
        "hc-a2": "BO",
        fips: "31011",
        name: "Boone",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6077, 7288],
            [6070, 7711],
            [6064, 7711],
            [6061, 7829],
            [6058, 7993],
            [6339, 7999],
            [6619, 8008],
            [6628, 7725],
            [6630, 7725],
            [6636, 7457],
            [6639, 7374],
            [6572, 7372],
            [6572, 7348],
            [6382, 7343],
            [6382, 7319],
            [6311, 7316],
            [6312, 7293],
            [6077, 7288],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.183",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-183",
        "hc-a2": "WH",
        fips: "31183",
        name: "Wheeler",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6058, 7993],
            [6061, 7829],
            [6064, 7711],
            [5724, 7703],
            [5508, 7700],
            [5500, 7700],
            [5493, 8040],
            [5489, 8266],
            [5950, 8273],
            [6047, 8276],
            [6053, 8276],
            [6058, 7993],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.027",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-027",
        "hc-a2": "CE",
        fips: "31027",
        name: "Cedar",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7163, 8731],
            [7159, 8872],
            [7017, 8868],
            [7000, 9431],
            [6998, 9537],
            [7053, 9533],
            [7078, 9565],
            [7145, 9549],
            [7210, 9572],
            [7231, 9553],
            [7317, 9538],
            [7326, 9485],
            [7389, 9467],
            [7426, 9422],
            [7496, 9426],
            [7564, 9410],
            [7569, 9290],
            [7585, 8744],
            [7420, 8739],
            [7163, 8731],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.095",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-095",
        "hc-a2": "JE",
        fips: "31095",
        name: "Jefferson",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7662, 5492],
            [7823, 5497],
            [7837, 5089],
            [7843, 4932],
            [7582, 4923],
            [7277, 4914],
            [7265, 5315],
            [7261, 5480],
            [7261, 5480],
            [7261, 5480],
            [7662, 5492],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.151",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-151",
        "hc-a2": "SA",
        fips: "31151",
        name: "Saline",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [7662, 5492],
              [7261, 5480],
              [7261, 5480],
              [7259, 5520],
              [7244, 6046],
              [7244, 6046],
              [7244, 6046],
              [7596, 6056],
              [7806, 6063],
              [7811, 5921],
              [7817, 5780],
              [7826, 5507],
              [7823, 5497],
              [7662, 5492],
            ],
          ],
          [
            [
              [7244, 6046],
              [7244, 6046],
              [7244, 6046],
              [7244, 6046],
              [7244, 6046],
              [7244, 6046],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.035",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-035",
        "hc-a2": "CL",
        fips: "31035",
        name: "Clay",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6682, 5945],
            [6695, 5464],
            [6402, 5458],
            [6136, 5451],
            [6136, 5451],
            [6132, 5451],
            [6130, 5451],
            [6124, 5766],
            [6119, 6017],
            [6315, 6021],
            [6678, 6030],
            [6679, 6030],
            [6679, 6030],
            [6682, 5945],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.079",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-079",
        "hc-a2": "HA",
        fips: "31079",
        name: "Hall",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5936, 6013],
            [5571, 6008],
            [5565, 6315],
            [5562, 6573],
            [5562, 6573],
            [5789, 6577],
            [6097, 6582],
            [6102, 6582],
            [6108, 6293],
            [6111, 6148],
            [6113, 6017],
            [6110, 6016],
            [5936, 6013],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.001",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-001",
        "hc-a2": "AD",
        fips: "31001",
        name: "Adams",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5571, 6008],
            [5936, 6013],
            [6113, 6017],
            [6116, 6017],
            [6119, 6017],
            [6124, 5766],
            [6130, 5451],
            [5883, 5447],
            [5576, 5442],
            [5572, 5701],
            [5567, 5993],
            [5567, 6008],
            [5571, 6008],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.185",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-185",
        "hc-a2": "YO",
        fips: "31185",
        name: "York",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7244, 6046],
            [6885, 6035],
            [6679, 6030],
            [6679, 6030],
            [6678, 6030],
            [6670, 6331],
            [6663, 6595],
            [6944, 6603],
            [7227, 6611],
            [7232, 6436],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.159",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-159",
        "hc-a2": "SE",
        fips: "31159",
        name: "Seward",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7596, 6056],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
            [7244, 6046],
            [7232, 6436],
            [7227, 6611],
            [7464, 6618],
            [7789, 6629],
            [7809, 6063],
            [7806, 6063],
            [7596, 6056],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.067",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-067",
        "hc-a2": "GA",
        fips: "31067",
        name: "Gage",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7823, 5497],
            [7826, 5507],
            [7817, 5780],
            [8088, 5789],
            [8374, 5800],
            [8386, 5506],
            [8391, 5377],
            [8396, 5252],
            [8408, 4953],
            [7937, 4935],
            [7843, 4932],
            [7837, 5089],
            [7823, 5497],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.097",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-097",
        "hc-a2": "JO",
        fips: "31097",
        name: "Johnson",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8391, 5377],
            [8386, 5506],
            [8374, 5800],
            [8655, 5812],
            [8865, 5822],
            [8879, 5539],
            [8885, 5398],
            [8533, 5383],
            [8391, 5377],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.007",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.28,
        "hc-middle-y": 0.4,
        "hc-key": "us-ne-007",
        "hc-a2": "BA",
        fips: "31007",
        name: "Banner",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-115, 7702],
            [-121, 7430],
            [-130, 7277],
            [-134, 7207],
            [-143, 7208],
            [-143, 7208],
            [-446, 7218],
            [-968, 7241],
            [-955, 7519],
            [-945, 7736],
            [-487, 7715],
            [-115, 7702],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.123",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.55,
        "hc-key": "us-ne-123",
        "hc-a2": "MO",
        fips: "31123",
        name: "Morrill",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-130, 7277],
            [-121, 7430],
            [-115, 7702],
            [-103, 7774],
            [-87, 8195],
            [201, 8185],
            [520, 8169],
            [719, 8170],
            [735, 8170],
            [744, 8170],
            [734, 7906],
            [746, 7744],
            [781, 7742],
            [765, 7248],
            [454, 7259],
            [-130, 7277],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.019",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-019",
        "hc-a2": "BU",
        fips: "31019",
        name: "Buffalo",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4696, 6564],
            [4845, 6566],
            [4964, 6567],
            [5443, 6572],
            [5529, 6573],
            [5539, 6573],
            [5560, 6573],
            [5562, 6573],
            [5562, 6573],
            [5565, 6315],
            [5571, 6008],
            [5567, 6008],
            [5567, 5993],
            [5441, 5967],
            [5343, 5930],
            [5231, 5928],
            [5005, 5939],
            [4924, 5936],
            [4816, 5955],
            [4710, 5953],
            [4699, 6000],
            [4696, 6564],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.041",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-041",
        "hc-a2": "CU",
        fips: "31041",
        name: "Custer",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4964, 6567],
            [4845, 6566],
            [4696, 6564],
            [4143, 6563],
            [3713, 6562],
            [3696, 6562],
            [3702, 6941],
            [3700, 7125],
            [3682, 7125],
            [3681, 7498],
            [3684, 7689],
            [3984, 7686],
            [4371, 7690],
            [4890, 7695],
            [4937, 7694],
            [4948, 7694],
            [4949, 7694],
            [4953, 7131],
            [4964, 7131],
            [4965, 6897],
            [4964, 6567],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.131",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-131",
        "hc-a2": "OT",
        fips: "31131",
        name: "Otoe",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8865, 5822],
            [8655, 5812],
            [8374, 5800],
            [8365, 6012],
            [8356, 6224],
            [8779, 6242],
            [9133, 6258],
            [9077, 6202],
            [9078, 6148],
            [9131, 6085],
            [9198, 6059],
            [9249, 5980],
            [9234, 5940],
            [9249, 5845],
            [9258, 5840],
            [8865, 5822],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.127",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.36,
        "hc-middle-y": 0.56,
        "hc-key": "us-ne-127",
        "hc-a2": "NE",
        fips: "31127",
        name: "Nemaha",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8865, 5822],
            [9249, 5845],
            [9307, 5844],
            [9324, 5899],
            [9352, 5909],
            [9368, 5836],
            [9321, 5814],
            [9333, 5757],
            [9376, 5718],
            [9376, 5672],
            [9425, 5538],
            [9390, 5516],
            [9521, 5476],
            [9524, 5429],
            [9091, 5406],
            [8955, 5400],
            [8929, 5399],
            [8885, 5398],
            [8879, 5539],
            [8865, 5822],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.141",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.47,
        "hc-key": "us-ne-141",
        "hc-a2": "PL",
        fips: "31141",
        name: "Platte",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [6799, 7165],
              [6794, 7379],
              [6639, 7374],
              [6636, 7457],
              [6630, 7725],
              [7076, 7739],
              [7192, 7742],
              [7268, 7745],
              [7333, 7747],
              [7351, 7181],
              [7350, 7164],
              [7308, 7189],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7111, 7131],
              [7023, 7118],
              [6931, 7068],
              [6928, 7169],
              [6799, 7165],
            ],
          ],
          [
            [
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
              [7209, 7179],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.125",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-125",
        "hc-a2": "NA",
        fips: "31125",
        name: "Nance",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6639, 7374],
            [6794, 7379],
            [6799, 7165],
            [6801, 7025],
            [6565, 7018],
            [6566, 6994],
            [6375, 6989],
            [6376, 6965],
            [6316, 6964],
            [6317, 6940],
            [6104, 6936],
            [6102, 7147],
            [6086, 7147],
            [6083, 7147],
            [6080, 7147],
            [6079, 7194],
            [6077, 7288],
            [6312, 7293],
            [6311, 7316],
            [6382, 7319],
            [6382, 7343],
            [6572, 7348],
            [6572, 7372],
            [6639, 7374],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.133",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-133",
        "hc-a2": "PA",
        fips: "31133",
        name: "Pawnee",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8408, 4953],
            [8396, 5252],
            [8391, 5377],
            [8533, 5383],
            [8885, 5398],
            [8929, 5399],
            [8955, 5400],
            [8963, 5224],
            [8974, 4977],
            [8689, 4964],
            [8408, 4953],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.109",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-109",
        "hc-a2": "LA",
        fips: "31109",
        name: "Lancaster",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8356, 6224],
            [8365, 6012],
            [8374, 5800],
            [8088, 5789],
            [7817, 5780],
            [7811, 5921],
            [7806, 6063],
            [7809, 6063],
            [7789, 6629],
            [7792, 6629],
            [8339, 6648],
            [8341, 6601],
            [8352, 6325],
            [8356, 6224],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.161",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.48,
        "hc-middle-y": 0.24,
        "hc-key": "us-ne-161",
        "hc-a2": "SH",
        fips: "31161",
        name: "Sheridan",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1561, 8296],
            [1555, 8154],
            [1484, 8156],
            [959, 8167],
            [744, 8170],
            [735, 8170],
            [719, 8170],
            [718, 8313],
            [670, 8314],
            [679, 8879],
            [650, 8880],
            [668, 9441],
            [645, 9441],
            [657, 9790],
            [824, 9785],
            [1504, 9766],
            [1493, 9418],
            [1514, 9417],
            [1501, 8862],
            [1536, 8860],
            [1520, 8297],
            [1561, 8296],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.075",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-075",
        "hc-a2": "GR",
        fips: "31075",
        name: "Grant",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1484, 8156],
            [1555, 8154],
            [1561, 8296],
            [1838, 8285],
            [2262, 8275],
            [2260, 8125],
            [2254, 7708],
            [2011, 7711],
            [1573, 7720],
            [1472, 7722],
            [1484, 8156],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.137",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-137",
        "hc-a2": "PH",
        fips: "31137",
        name: "Phelps",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4430, 5975],
            [4573, 5959],
            [4677, 5965],
            [4710, 5953],
            [4816, 5955],
            [4924, 5936],
            [5005, 5939],
            [5006, 5803],
            [5010, 5435],
            [4691, 5433],
            [4449, 5432],
            [4449, 5432],
            [4434, 5432],
            [4431, 5540],
            [4430, 5975],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.047",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.46,
        "hc-key": "us-ne-047",
        "hc-a2": "DA",
        fips: "31047",
        name: "Dawson",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4710, 5953],
            [4677, 5965],
            [4573, 5959],
            [4430, 5975],
            [4358, 5999],
            [4012, 5998],
            [3855, 5999],
            [3713, 5999],
            [3713, 5999],
            [3713, 5999],
            [3713, 6305],
            [3713, 6562],
            [4143, 6563],
            [4696, 6564],
            [4699, 6000],
            [4710, 5953],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.111",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-111",
        "hc-a2": "LI",
        fips: "31111",
        name: "Lincoln",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3713, 5999],
            [3302, 6001],
            [3027, 6003],
            [2752, 6005],
            [2446, 6006],
            [2450, 6277],
            [2451, 6503],
            [2451, 6574],
            [2426, 6574],
            [2436, 7139],
            [2631, 7137],
            [3117, 7129],
            [3592, 7126],
            [3682, 7125],
            [3700, 7125],
            [3702, 6941],
            [3696, 6562],
            [3713, 6562],
            [3713, 6305],
            [3713, 5999],
            [3713, 5999],
            [3713, 5999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.003",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-003",
        "hc-a2": "AN",
        fips: "31003",
        name: "Antelope",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6058, 7993],
            [6053, 8276],
            [6047, 8276],
            [6038, 8715],
            [6036, 8841],
            [6404, 8850],
            [6597, 8855],
            [6606, 8455],
            [6611, 8290],
            [6615, 8136],
            [6619, 8008],
            [6339, 7999],
            [6058, 7993],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.167",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-167",
        "hc-a2": "ST",
        fips: "31167",
        name: "Stanton",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7616, 7756],
            [7467, 7751],
            [7333, 7747],
            [7268, 7745],
            [7192, 7742],
            [7182, 8095],
            [7175, 8307],
            [7357, 8313],
            [7597, 8320],
            [7606, 8064],
            [7616, 7756],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.063",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-063",
        "hc-a2": "FR",
        fips: "31063",
        name: "Frontier",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3046, 5433],
            [3034, 5433],
            [3023, 5433],
            [3023, 5433],
            [3023, 5433],
            [3019, 5745],
            [3027, 6003],
            [3302, 6001],
            [3713, 5999],
            [3713, 5999],
            [3855, 5999],
            [4012, 5998],
            [4013, 5573],
            [3871, 5574],
            [3871, 5432],
            [3820, 5431],
            [3743, 5430],
            [3513, 5433],
            [3046, 5433],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.057",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-057",
        "hc-a2": "DU",
        fips: "31057",
        name: "Dundy",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2320, 5443],
            [2334, 5443],
            [2344, 5443],
            [2341, 5409],
            [2333, 4878],
            [1425, 4896],
            [1439, 5458],
            [1814, 5451],
            [2320, 5443],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.033",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-033",
        "hc-a2": "CH",
        fips: "31033",
        name: "Cheyenne",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-143, 7208],
            [-134, 7207],
            [-130, 7277],
            [454, 7259],
            [765, 7248],
            [763, 7177],
            [797, 7176],
            [787, 6894],
            [779, 6613],
            [763, 6539],
            [294, 6554],
            [-174, 6571],
            [-163, 6644],
            [-143, 7208],
            [-143, 7208],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.055",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-055",
        "hc-a2": "DO",
        fips: "31055",
        name: "Douglas",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8307, 7213],
            [8344, 7214],
            [8481, 7220],
            [8958, 7241],
            [8959, 7238],
            [8972, 7205],
            [8938, 7170],
            [8980, 7126],
            [9028, 7123],
            [9041, 7069],
            [8998, 7058],
            [8992, 6914],
            [8728, 6902],
            [8497, 6890],
            [8447, 6960],
            [8463, 7011],
            [8390, 7088],
            [8366, 7171],
            [8307, 7213],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.105",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.61,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-105",
        "hc-a2": "KI",
        fips: "31105",
        name: "Kimball",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-143, 7208],
            [-143, 7208],
            [-163, 6644],
            [-174, 6571],
            [-999, 6605],
            [-968, 7241],
            [-446, 7218],
            [-143, 7208],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.081",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.68,
        "hc-key": "us-ne-081",
        "hc-a2": "HA",
        fips: "31081",
        name: "Hamilton",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6116, 6017],
            [6113, 6017],
            [6113, 6017],
            [6111, 6148],
            [6108, 6293],
            [6199, 6406],
            [6244, 6436],
            [6272, 6485],
            [6342, 6527],
            [6436, 6632],
            [6588, 6704],
            [6656, 6801],
            [6661, 6595],
            [6663, 6595],
            [6670, 6331],
            [6678, 6030],
            [6315, 6021],
            [6119, 6017],
            [6116, 6017],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.017",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.54,
        "hc-key": "us-ne-017",
        "hc-a2": "BR",
        fips: "31017",
        name: "Brown",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4398, 8252],
            [4395, 8252],
            [4368, 8252],
            [4017, 8250],
            [3786, 8251],
            [3788, 8815],
            [3769, 8816],
            [3770, 9381],
            [3752, 9381],
            [3752, 9487],
            [3809, 9464],
            [3829, 9424],
            [3922, 9388],
            [3980, 9393],
            [4027, 9367],
            [4154, 9361],
            [4163, 9335],
            [4255, 9306],
            [4376, 9300],
            [4380, 8818],
            [4394, 8818],
            [4398, 8252],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.115",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-115",
        "hc-a2": "LO",
        fips: "31115",
        name: "Loup",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4368, 8252],
            [4395, 8252],
            [4398, 8252],
            [4767, 8255],
            [4916, 8258],
            [4929, 8258],
            [4930, 8258],
            [4932, 8057],
            [4937, 7694],
            [4890, 7695],
            [4371, 7690],
            [4370, 7996],
            [4368, 8252],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.009",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-009",
        "hc-a2": "BL",
        fips: "31009",
        name: "Blaine",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3684, 7689],
            [3674, 7689],
            [3666, 7689],
            [3666, 7908],
            [3665, 8251],
            [3690, 8251],
            [3786, 8251],
            [4017, 8250],
            [4368, 8252],
            [4370, 7996],
            [4371, 7690],
            [3984, 7686],
            [3684, 7689],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.113",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-113",
        "hc-a2": "LO",
        fips: "31113",
        name: "Logan",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3666, 7689],
            [3674, 7689],
            [3684, 7689],
            [3681, 7498],
            [3682, 7125],
            [3592, 7126],
            [3117, 7129],
            [3117, 7375],
            [3123, 7692],
            [3392, 7689],
            [3666, 7689],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.121",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.32,
        "hc-middle-y": 0.47,
        "hc-key": "us-ne-121",
        "hc-a2": "ME",
        fips: "31121",
        name: "Merrick",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6799, 7165],
            [6928, 7169],
            [6931, 7068],
            [6932, 7042],
            [6858, 7020],
            [6730, 6903],
            [6656, 6801],
            [6588, 6704],
            [6436, 6632],
            [6342, 6527],
            [6272, 6485],
            [6244, 6436],
            [6199, 6406],
            [6108, 6293],
            [6102, 6582],
            [6097, 6582],
            [6091, 6873],
            [6086, 7147],
            [6102, 7147],
            [6104, 6936],
            [6317, 6940],
            [6316, 6964],
            [6376, 6965],
            [6375, 6989],
            [6566, 6994],
            [6565, 7018],
            [6801, 7025],
            [6799, 7165],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.163",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-163",
        "hc-a2": "SH",
        fips: "31163",
        name: "Sherman",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5517, 7137],
            [5519, 7137],
            [5526, 7138],
            [5527, 6668],
            [5529, 6573],
            [5443, 6572],
            [4964, 6567],
            [4965, 6897],
            [4964, 7131],
            [5501, 7138],
            [5517, 7137],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.023",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.57,
        "hc-key": "us-ne-023",
        "hc-a2": "BU",
        fips: "31023",
        name: "Butler",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7771, 7295],
            [7772, 7292],
            [7772, 7290],
            [7779, 6982],
            [7792, 6629],
            [7789, 6629],
            [7464, 6618],
            [7227, 6611],
            [7217, 6946],
            [7209, 7179],
            [7209, 7179],
            [7209, 7179],
            [7209, 7179],
            [7308, 7189],
            [7350, 7164],
            [7446, 7155],
            [7548, 7184],
            [7589, 7217],
            [7640, 7221],
            [7700, 7269],
            [7771, 7295],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.143",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.57,
        "hc-middle-y": 0.58,
        "hc-key": "us-ne-143",
        "hc-a2": "PO",
        fips: "31143",
        name: "Polk",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6931, 7068],
            [7023, 7118],
            [7111, 7131],
            [7209, 7179],
            [7209, 7179],
            [7209, 7179],
            [7209, 7179],
            [7217, 6946],
            [7227, 6611],
            [6944, 6603],
            [6663, 6595],
            [6661, 6595],
            [6656, 6801],
            [6730, 6903],
            [6858, 7020],
            [6932, 7042],
            [6931, 7068],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.175",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-175",
        "hc-a2": "VA",
        fips: "31175",
        name: "Valley",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5500, 7700],
            [5508, 7700],
            [5514, 7396],
            [5517, 7137],
            [5501, 7138],
            [4964, 7131],
            [4953, 7131],
            [4949, 7694],
            [5358, 7698],
            [5500, 7700],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.025",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.51,
        "hc-key": "us-ne-025",
        "hc-a2": "CA",
        fips: "31025",
        name: "Cass",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8356, 6224],
            [8352, 6325],
            [8341, 6601],
            [8481, 6605],
            [8480, 6653],
            [8517, 6655],
            [8561, 6619],
            [8603, 6616],
            [8657, 6581],
            [8733, 6620],
            [8774, 6672],
            [8838, 6703],
            [8931, 6686],
            [9056, 6693],
            [9080, 6670],
            [9080, 6603],
            [9120, 6579],
            [9120, 6482],
            [9153, 6423],
            [9110, 6388],
            [9133, 6258],
            [8779, 6242],
            [8356, 6224],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.119",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-119",
        "hc-a2": "MA",
        fips: "31119",
        name: "Madison",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6630, 7725],
            [6628, 7725],
            [6619, 8008],
            [6615, 8136],
            [6611, 8290],
            [6893, 8298],
            [7175, 8307],
            [7182, 8095],
            [7192, 7742],
            [7076, 7739],
            [6630, 7725],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.181",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-181",
        "hc-a2": "WE",
        fips: "31181",
        name: "Webster",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6136, 5451],
            [6136, 5451],
            [6137, 5414],
            [6143, 5080],
            [6147, 4887],
            [6147, 4886],
            [5859, 4881],
            [5581, 4876],
            [5577, 5229],
            [5572, 5442],
            [5576, 5442],
            [5576, 5442],
            [5883, 5447],
            [6130, 5451],
            [6132, 5451],
            [6136, 5451],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.129",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-129",
        "hc-a2": "NU",
        fips: "31129",
        name: "Nuckolls",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6136, 5451],
            [6136, 5451],
            [6136, 5451],
            [6402, 5458],
            [6695, 5464],
            [6698, 5464],
            [6699, 5464],
            [6711, 4971],
            [6712, 4898],
            [6297, 4889],
            [6147, 4887],
            [6147, 4886],
            [6143, 5079],
            [6143, 5080],
            [6141, 5170],
            [6137, 5414],
            [6137, 5416],
            [6136, 5451],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.099",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-099",
        "hc-a2": "KE",
        fips: "31099",
        name: "Kearney",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5576, 5442],
            [5576, 5442],
            [5572, 5442],
            [5420, 5440],
            [5010, 5435],
            [5006, 5803],
            [5005, 5939],
            [5231, 5928],
            [5343, 5930],
            [5441, 5967],
            [5567, 5993],
            [5572, 5701],
            [5576, 5442],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.089",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.55,
        "hc-key": "us-ne-089",
        "hc-a2": "HO",
        fips: "31089",
        name: "Holt",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4930, 8258],
            [4929, 8258],
            [4916, 8258],
            [4912, 8821],
            [4899, 8821],
            [4893, 9387],
            [4879, 9422],
            [5002, 9485],
            [5118, 9519],
            [5165, 9558],
            [5239, 9572],
            [5314, 9494],
            [5377, 9495],
            [5429, 9461],
            [5469, 9467],
            [5534, 9429],
            [5597, 9439],
            [5686, 9392],
            [5831, 9373],
            [5887, 9389],
            [6020, 9368],
            [6030, 8841],
            [6036, 8841],
            [6038, 8715],
            [6047, 8276],
            [5950, 8273],
            [5489, 8266],
            [5151, 8261],
            [4930, 8258],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.031",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-031",
        "hc-a2": "CH",
        fips: "31031",
        name: "Cherry",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3753, 9735],
            [3752, 9594],
            [3752, 9487],
            [3752, 9381],
            [3770, 9381],
            [3769, 8816],
            [3788, 8815],
            [3786, 8251],
            [3690, 8251],
            [3665, 8251],
            [3250, 8255],
            [2965, 8259],
            [2551, 8269],
            [2262, 8275],
            [1838, 8285],
            [1561, 8296],
            [1520, 8297],
            [1536, 8860],
            [1501, 8862],
            [1514, 9417],
            [1493, 9418],
            [1504, 9765],
            [1504, 9765],
            [1504, 9766],
            [1504, 9766],
            [1766, 9760],
            [2040, 9749],
            [2524, 9744],
            [3753, 9735],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.103",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-103",
        "hc-a2": "KP",
        fips: "31103",
        name: "Keya Paha",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3752, 9487],
            [3752, 9594],
            [3753, 9735],
            [3949, 9734],
            [4879, 9737],
            [4877, 9581],
            [4879, 9422],
            [4784, 9383],
            [4690, 9368],
            [4624, 9313],
            [4544, 9279],
            [4376, 9300],
            [4255, 9306],
            [4163, 9335],
            [4154, 9361],
            [4027, 9367],
            [3980, 9393],
            [3922, 9388],
            [3829, 9424],
            [3809, 9464],
            [3752, 9487],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.015",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.7,
        "hc-middle-y": 0.49,
        "hc-key": "us-ne-015",
        "hc-a2": "BO",
        fips: "31015",
        name: "Boyd",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4879, 9422],
            [4877, 9581],
            [4879, 9737],
            [5781, 9750],
            [5820, 9668],
            [6010, 9566],
            [6013, 9406],
            [6020, 9368],
            [5887, 9389],
            [5831, 9373],
            [5686, 9392],
            [5597, 9439],
            [5534, 9429],
            [5469, 9467],
            [5429, 9461],
            [5377, 9495],
            [5314, 9494],
            [5239, 9572],
            [5165, 9558],
            [5118, 9519],
            [5002, 9485],
            [4879, 9422],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.093",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-093",
        "hc-a2": "HO",
        fips: "31093",
        name: "Howard",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5539, 6573],
            [5529, 6573],
            [5527, 6668],
            [5526, 7138],
            [5824, 7142],
            [6080, 7147],
            [6083, 7147],
            [6086, 7147],
            [6091, 6873],
            [6097, 6582],
            [5789, 6577],
            [5562, 6573],
            [5562, 6573],
            [5560, 6573],
            [5559, 6573],
            [5539, 6573],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.071",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-071",
        "hc-a2": "GA",
        fips: "31071",
        name: "Garfield",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4949, 7694],
            [4948, 7694],
            [4937, 7694],
            [4932, 8057],
            [4930, 8258],
            [5151, 8261],
            [5489, 8266],
            [5493, 8040],
            [5500, 7700],
            [5358, 7698],
            [4949, 7694],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.135",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-135",
        "hc-a2": "PE",
        fips: "31135",
        name: "Perkins",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2446, 6006],
            [2423, 6006],
            [2325, 6008],
            [1984, 6017],
            [1452, 6024],
            [1464, 6514],
            [1464, 6522],
            [1464, 6522],
            [1719, 6515],
            [2451, 6503],
            [2450, 6277],
            [2446, 6006],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.049",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-049",
        "hc-a2": "DE",
        fips: "31049",
        name: "Deuel",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1464, 6522],
            [1464, 6520],
            [927, 6534],
            [763, 6539],
            [779, 6613],
            [787, 6894],
            [834, 6894],
            [1467, 6876],
            [1461, 6593],
            [1464, 6522],
            [1464, 6522],
            [1464, 6522],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.101",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-101",
        "hc-a2": "KE",
        fips: "31101",
        name: "Keith",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1464, 6522],
            [1461, 6593],
            [1467, 6876],
            [1474, 7158],
            [1561, 7155],
            [2000, 7147],
            [2267, 7142],
            [2306, 7142],
            [2436, 7139],
            [2426, 6574],
            [2451, 6574],
            [2451, 6503],
            [1719, 6515],
            [1464, 6522],
            [1464, 6522],
            [1464, 6522],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.107",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.52,
        "hc-key": "us-ne-107",
        "hc-a2": "KN",
        fips: "31107",
        name: "Knox",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6020, 9368],
            [6013, 9406],
            [6010, 9566],
            [6072, 9553],
            [6119, 9520],
            [6199, 9498],
            [6309, 9407],
            [6370, 9377],
            [6448, 9393],
            [6516, 9470],
            [6530, 9538],
            [6583, 9556],
            [6652, 9527],
            [6757, 9517],
            [6818, 9534],
            [6906, 9530],
            [6974, 9550],
            [6998, 9537],
            [7000, 9431],
            [7017, 8868],
            [6765, 8860],
            [6597, 8855],
            [6404, 8850],
            [6036, 8841],
            [6030, 8841],
            [6020, 9368],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.153",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.36,
        "hc-key": "us-ne-153",
        "hc-a2": "SA",
        fips: "31153",
        name: "Sarpy",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8517, 6655],
            [8489, 6715],
            [8522, 6770],
            [8497, 6890],
            [8728, 6902],
            [8992, 6914],
            [9060, 6913],
            [9092, 6883],
            [9047, 6866],
            [9075, 6753],
            [9056, 6693],
            [8931, 6686],
            [8838, 6703],
            [8774, 6672],
            [8733, 6620],
            [8657, 6581],
            [8603, 6616],
            [8561, 6619],
            [8517, 6655],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.155",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.44,
        "hc-middle-y": 0.53,
        "hc-key": "us-ne-155",
        "hc-a2": "SA",
        fips: "31155",
        name: "Saunders",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8497, 6890],
            [8522, 6770],
            [8489, 6715],
            [8517, 6655],
            [8480, 6653],
            [8481, 6605],
            [8341, 6601],
            [8339, 6648],
            [7792, 6629],
            [7779, 6982],
            [7772, 7290],
            [7878, 7273],
            [7966, 7291],
            [8031, 7255],
            [8097, 7274],
            [8185, 7273],
            [8276, 7213],
            [8307, 7213],
            [8366, 7171],
            [8390, 7088],
            [8463, 7011],
            [8447, 6960],
            [8497, 6890],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.013",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.38,
        "hc-middle-y": 0.43,
        "hc-key": "us-ne-013",
        "hc-a2": "BB",
        fips: "31013",
        name: "Box Butte",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87, 8195],
            [-112, 8197],
            [-133, 8198],
            [-128, 8339],
            [-179, 8341],
            [-157, 8904],
            [377, 8885],
            [650, 8880],
            [679, 8879],
            [670, 8314],
            [718, 8313],
            [719, 8170],
            [520, 8169],
            [201, 8185],
            [-87, 8195],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.005",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-005",
        "hc-a2": "AR",
        fips: "31005",
        name: "Arthur",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2254, 7708],
            [2277, 7708],
            [2274, 7492],
            [2267, 7142],
            [2000, 7147],
            [1561, 7155],
            [1565, 7326],
            [1573, 7720],
            [2011, 7711],
            [2254, 7708],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.091",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-091",
        "hc-a2": "HO",
        fips: "31091",
        name: "Hooker",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2277, 7708],
            [2254, 7708],
            [2260, 8125],
            [2262, 8275],
            [2551, 8269],
            [2965, 8259],
            [2965, 7974],
            [2964, 7694],
            [2619, 7701],
            [2277, 7708],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.061",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-061",
        "hc-a2": "FR",
        fips: "31061",
        name: "Franklin",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5010, 5435],
            [5420, 5440],
            [5572, 5442],
            [5577, 5229],
            [5581, 4876],
            [5172, 4871],
            [5015, 4869],
            [5012, 5164],
            [5010, 5435],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.029",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-029",
        "hc-a2": "CH",
        fips: "31029",
        name: "Chase",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2320, 5443],
            [1814, 5451],
            [1439, 5458],
            [1444, 5703],
            [1452, 6024],
            [1984, 6017],
            [2325, 6008],
            [2322, 5727],
            [2320, 5443],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.021",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-021",
        "hc-a2": "BU",
        fips: "31021",
        name: "Burt",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8503, 8285],
            [8566, 8259],
            [8545, 8210],
            [8613, 8221],
            [8624, 8175],
            [8678, 8175],
            [8677, 8097],
            [8648, 8057],
            [8678, 7998],
            [8713, 7974],
            [8717, 7931],
            [8774, 7881],
            [8728, 7794],
            [8765, 7732],
            [8712, 7702],
            [8569, 7696],
            [8320, 7686],
            [8316, 7780],
            [8181, 7775],
            [8164, 8197],
            [8164, 8220],
            [8461, 8231],
            [8459, 8282],
            [8503, 8285],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.147",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.49,
        "hc-key": "us-ne-147",
        "hc-a2": "RI",
        fips: "31147",
        name: "Richardson",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [9524, 5429],
            [9618, 5404],
            [9624, 5307],
            [9672, 5274],
            [9685, 5237],
            [9730, 5216],
            [9707, 5094],
            [9745, 5058],
            [9801, 5063],
            [9851, 5020],
            [8974, 4977],
            [8963, 5224],
            [8955, 5400],
            [9091, 5406],
            [9524, 5429],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.069",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.47,
        "hc-middle-y": 0.46,
        "hc-key": "us-ne-069",
        "hc-a2": "GA",
        fips: "31069",
        name: "Garden",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1573, 7720],
            [1565, 7326],
            [1561, 7155],
            [1474, 7158],
            [1467, 6876],
            [834, 6894],
            [787, 6894],
            [797, 7176],
            [763, 7177],
            [765, 7248],
            [781, 7742],
            [746, 7744],
            [734, 7906],
            [744, 8170],
            [959, 8167],
            [1484, 8156],
            [1472, 7722],
            [1573, 7720],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.171",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-171",
        "hc-a2": "TH",
        fips: "31171",
        name: "Thomas",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2965, 8259],
            [3250, 8255],
            [3665, 8251],
            [3666, 7908],
            [3666, 7689],
            [3392, 7689],
            [3123, 7692],
            [3083, 7692],
            [2964, 7694],
            [2965, 7974],
            [2965, 8259],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.073",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.62,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-073",
        "hc-a2": "GO",
        fips: "31073",
        name: "Gosper",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4430, 5975],
            [4431, 5540],
            [4434, 5432],
            [4131, 5431],
            [3871, 5432],
            [3871, 5574],
            [4013, 5573],
            [4012, 5998],
            [4358, 5999],
            [4430, 5975],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.051",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.46,
        "hc-middle-y": 0.43,
        "hc-key": "us-ne-051",
        "hc-a2": "DI",
        fips: "31051",
        name: "Dixon",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7564, 9410],
            [7608, 9410],
            [7629, 9346],
            [7695, 9370],
            [7818, 9326],
            [7825, 9275],
            [7914, 9269],
            [7962, 9234],
            [7938, 9175],
            [7969, 9129],
            [8029, 9087],
            [8039, 9042],
            [7930, 9039],
            [7940, 8638],
            [7941, 8615],
            [7825, 8611],
            [7589, 8603],
            [7585, 8744],
            [7569, 9290],
            [7564, 9410],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.043",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.39,
        "hc-middle-y": 0.49,
        "hc-key": "us-ne-043",
        "hc-a2": "DA",
        fips: "31043",
        name: "Dakota",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8039, 9042],
            [8074, 9011],
            [8128, 9039],
            [8168, 9024],
            [8198, 8981],
            [8317, 8992],
            [8346, 8928],
            [8312, 8872],
            [8320, 8749],
            [8368, 8708],
            [8387, 8653],
            [8152, 8645],
            [7940, 8638],
            [7930, 9039],
            [8039, 9042],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.177",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.35,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-177",
        "hc-a2": "WA",
        fips: "31177",
        name: "Washington",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8959, 7238],
            [8958, 7241],
            [8481, 7220],
            [8478, 7291],
            [8431, 7289],
            [8405, 7335],
            [8357, 7357],
            [8331, 7427],
            [8320, 7686],
            [8569, 7696],
            [8712, 7702],
            [8747, 7643],
            [8729, 7571],
            [8770, 7527],
            [8760, 7462],
            [8825, 7420],
            [8839, 7475],
            [8872, 7475],
            [8879, 7423],
            [8852, 7397],
            [8872, 7366],
            [8970, 7349],
            [8959, 7238],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.039",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-039",
        "hc-a2": "CU",
        fips: "31039",
        name: "Cuming",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7616, 7756],
            [7606, 8064],
            [7597, 8320],
            [7733, 8325],
            [7834, 8329],
            [8158, 8340],
            [8164, 8220],
            [8164, 8197],
            [8181, 7775],
            [7985, 7768],
            [7755, 7760],
            [7673, 7758],
            [7616, 7756],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.117",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-117",
        "hc-a2": "MC",
        fips: "31117",
        name: "Mcpherson",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2267, 7142],
            [2274, 7492],
            [2277, 7708],
            [2619, 7701],
            [2964, 7694],
            [3083, 7692],
            [3123, 7692],
            [3117, 7375],
            [3117, 7129],
            [2631, 7137],
            [2436, 7139],
            [2306, 7142],
            [2267, 7142],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.145",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-145",
        "hc-a2": "RW",
        fips: "31145",
        name: "Red Willow",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3747, 4864],
            [3370, 4865],
            [3041, 4869],
            [3041, 5149],
            [3046, 5433],
            [3513, 5433],
            [3743, 5430],
            [3746, 5315],
            [3747, 4864],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.149",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.55,
        "hc-key": "us-ne-149",
        "hc-a2": "RO",
        fips: "31149",
        name: "Rock",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4879, 9422],
            [4893, 9387],
            [4899, 8821],
            [4912, 8821],
            [4916, 8258],
            [4767, 8255],
            [4398, 8252],
            [4394, 8818],
            [4380, 8818],
            [4376, 9300],
            [4544, 9279],
            [4624, 9313],
            [4690, 9368],
            [4784, 9383],
            [4879, 9422],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.045",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.5,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-045",
        "hc-a2": "DA",
        fips: "31045",
        name: "Dawes",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-157, 8904],
            [-200, 8906],
            [-178, 9471],
            [-205, 9472],
            [-193, 9823],
            [408, 9800],
            [657, 9790],
            [645, 9441],
            [668, 9441],
            [650, 8880],
            [377, 8885],
            [-157, 8904],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: "US.NE.173",
      properties: {
        "hc-group": "admin2",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.5,
        "hc-key": "us-ne-173",
        "hc-a2": "TH",
        fips: "31173",
        name: "Thurston",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8387, 8653],
            [8429, 8579],
            [8391, 8553],
            [8406, 8472],
            [8505, 8387],
            [8503, 8285],
            [8459, 8282],
            [8461, 8231],
            [8164, 8220],
            [8158, 8340],
            [7834, 8329],
            [7828, 8520],
            [7825, 8611],
            [7941, 8615],
            [7940, 8638],
            [8152, 8645],
            [8387, 8653],
          ],
        ],
      },
    },
  ],
};

export default mapData;
